import { usePortalConfig } from "@/hooks/PortalConfig";
import * as React from "react";
import { MessageBar } from "../../molecules/MessageBar/MessageBar";
import useSessionStorage from "use-session-storage-state";
import { useIsOnline } from "react-use-is-online";
import { useLocation, matchPath } from "react-router-dom";

export interface IPortalMessagesProps {}

export function PortalMessages(props: IPortalMessagesProps) {
	const pc = usePortalConfig();
	const { isOnline } = useIsOnline();
	const location = useLocation();
	const [dismissedMessages, setDismissedMessges] = useSessionStorage<string[]>(
		"dismissed-portal-message",
		{
			storageSync: false,
		}
	);

	const dismissMessage = React.useCallback(
		(messageKey: string) => {
			setDismissedMessges([...(dismissedMessages ?? []), messageKey]);
		},
		[dismissedMessages, setDismissedMessges]
	);

	return (
		<div>
			{pc.data?.messages
				?.filter((i) => !i.pathFilter || matchPath(i.pathFilter, location.pathname))
				.map((i) => (
					<MessageBar
						key={`message-${i.key}`}
						message={i.message ?? ""}
						dismissable={i.dismissable}
						messageType={i.type}
						hidden={i.dismissable && dismissedMessages?.includes(i.key!)}
						onDismiss={() => dismissMessage(i.key!)}
						buttonText={i.buttonText}
						buttonUrl={i.buttonUrl}
					/>
				))}
			<MessageBar message={"You are currently offline."} messageType="error" hidden={isOnline} />
		</div>
	);
}
